import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultUnMappedUsersPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};
const defaultUnMappedUsersFilter = {
	$skip: defaultUnMappedUsersPagination.$skip,
	$limit: defaultUnMappedUsersPagination.$limit,
};
export default {
	state: {
		unMappedUsers: [],
		unMappedRecord: [],
		unMappedUsersPagination: defaultUnMappedUsersPagination,
		UnMappedUsersFilter: defaultUnMappedUsersFilter,
	},
	getters: {
		setunMappedUsersPage: (state) => {
			const { $limit, $skip } = state.unMappedUsersPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_UNMAPPED_USERS: (state, data) => { state.unMappedUsers = data; },
		SET_UNMAPPED_USERS_PAGINATION: (state, data) => { state.unMappedUsersPagination = { ...state.unMappedUsersPagination, ...data }; },
		SET_UNMAPPED_USERS_FILTER: (state, filter) => { state.UnMappedUsersFilter = { ...state.UnMappedUsersFilter, ...filter }; },
		SET_UNMAPPED_USERS_PERMISSION: (state, unMappedUsersPermission) => { state.unMappedUsersPermission = unMappedUsersPermission; },
		SET_UNMAPPED_USERS_RECORDS: (state, unMappedRecord) => { state.unMappedRecord = unMappedRecord; },

	},
	actions: {
		setUnMappedUsersFilter: ({ commit }, filter) => {
			commit('SET_UNMAPPED_USERS_FILTER', filter);
		},
		setunMappedUsersListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.unMappedUsersPagination.$limit;
			commit('SET_UNMAPPED_USERS_PAGINATION', { $skip });
			commit('SET_UNMAPPED_USERS_FILTER', { $skip });
		},
		getAllUnMappedUsersForTrust: async({ rootGetters, commit }, filter) => {
			
			const results = await feathersClient.service('api/v3/get-nurse-users').find({
				query: {
					fields: ['optimaStaffNumber'],
					$getNurseUser: true,
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_UNMAPPED_USERS', results.data);
			commit('SET_UNMAPPED_USERS_PAGINATION', { total: results.total });
			return results.data;
		},
		getAllUnMappedUsers: async ({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/get-trust-users').find({
				query: {
					fields: ['optimaStaffNumber'],
					$getUsersOfTrust: true,
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_UNMAPPED_USERS', results.data);
			commit('SET_UNMAPPED_USERS_PAGINATION', { total: results.total });
			return results.data;
		},
		getUnMappedUsersRecord({ commit }, userData) {
			commit('SET_UNMAPPED_USERS_RECORDS', userData);
		  },
	},
};
